import {ViewType} from "../../../../../../../../core/gd/const/views/view-type"
import {
    AddView_Group,
    AddView_GroupType
} from "../../../../../../../../core/gd-ui/add-view/@types"
import {PROJECT_LIST_CONFIG} from "../../../../../../../../core/views/list/@config"
import AddViewPreviewDefaultForm from "../preview/forms/default-form"
import {PROJECT_TABLE_CONFIG} from "../../../../../../../../core/views/table/@config"
import {PROJECT_BOARD_CONFIG} from "../../../../../../../../core/views/board/@config"
import {PROJECT_TABLE_MAP_CONFIG} from "../../../../../../../../core/gd/const/views/configs/dual-mode/project-map"
import {PROJECT_CALENDAR_CONFIG} from "../../../../../../../../core/views/calendar/@config"
import {PROJECT_TIMELINE_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project-timeline"
import {PROJECT_FILES_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-files"
import {PROJECT_DOCS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-docs"
import {PROJECT_GOALS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-goals"
import {
    PROJECT_DISCUSSION_CONFIG
} from "../../../../../../../../core/gd/const/views/configs/project/project-discussion"
import {PROJECT_MEETINGS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-meeting"
import {PROJECT_EXPENSES_CONFIG} from "../../../../../../../../core/views/expenses/@config"
import {Feature} from "../../../../../../../../core/gd/access-control/feature-access/const"
import {PROJECT_GANTT_CONFIG} from "../../../../../../../../core/views/gantt/@config"
import {PROJECT_WORKLOAD_CONFIG} from "../../../../../../../../core/views/workload/@config"
import {PROJECT_SUMMARY_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-summary"
import {PROJECT_ACTIVITY_CONFIG} from "../../../../../../../../core/views/activity/@config"
import {PROJECT_REPORTS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-reports"
import {PROJECT_DASHBOARD_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-dashboard"
import AddViewPreviewDashboardForm from "../preview/forms/dashboard-form"
import {
    PROJECT_EVENTS_SUMMARY_CONFIG
} from "../../../../../../../../core/gd/const/views/configs/project/events-summary";
import {PROJECT_TODOS_CONFIG} from "../../../../../../../../core/gd/const/views/configs/project/project-todos";

export default function addView_projectWorkspaceConfig(projectId: ID):AddView_Group[] {
    const res: AddView_Group[] = []

    res.push({
        type    : AddView_GroupType.GROUP,
        id      : 'tasks',
        icon    : 'i5-tasks',
        title   : 'Task Views',
        items   : [
            {
                typeId          : ViewType.PROJECT_LIST,
                iconSvg         : PROJECT_LIST_CONFIG.iconSvg,
                title           : PROJECT_LIST_CONFIG.name,
                description     : PROJECT_LIST_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_TABLE,
                iconSvg         : PROJECT_TABLE_CONFIG.iconSvg,
                title           : PROJECT_TABLE_CONFIG.name,
                description     : PROJECT_TABLE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_BOARD,
                iconSvg         : PROJECT_BOARD_CONFIG.iconSvg,
                title           : PROJECT_BOARD_CONFIG.name,
                description     : PROJECT_BOARD_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },

            {
                typeId          : ViewType.PROJECT_TABLE_MAP,
                iconSvg         : PROJECT_TABLE_MAP_CONFIG.iconSvg,
                title           : PROJECT_TABLE_MAP_CONFIG.name,
                description     : PROJECT_TABLE_MAP_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
        ]
    })

    res.push({
        title   : 'Events',
        type    : AddView_GroupType.GROUP,
        id      : 'events',
        icon    : 'i5-calendar',
        items   : [
            {
                typeId          : ViewType.PROJECT_CALENDAR,
                iconSvg         : PROJECT_CALENDAR_CONFIG.iconSvg,
                title           : PROJECT_CALENDAR_CONFIG.name,
                description     : PROJECT_CALENDAR_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_TIMELINE,
                iconSvg         : PROJECT_TIMELINE_CONFIG.iconSvg,
                title           : PROJECT_TIMELINE_CONFIG.name,
                description     : PROJECT_TIMELINE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_EVENTS_SUMMARY,
                iconSvg         : PROJECT_EVENTS_SUMMARY_CONFIG.iconSvg,
                title           : PROJECT_EVENTS_SUMMARY_CONFIG.name,
                description     : PROJECT_EVENTS_SUMMARY_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            }
        ]
    })

    // COLLABORATION

    res.push({
        type        : AddView_GroupType.GROUP,
        id          : 'collaboration',
        icon        : 'i5-users',
        title       : 'Collaboration',
        items       : [
            {
                typeId          : ViewType.PROJECT_TODOS,
                iconSvg         : PROJECT_TODOS_CONFIG.iconSvg,
                title           : PROJECT_TODOS_CONFIG.name,
                description     : PROJECT_TODOS_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm, // Need change !!!
            },
            {
                typeId          : ViewType.PROJECT_FILES,
                iconSvg         : PROJECT_FILES_CONFIG.iconSvg,
                title           : PROJECT_FILES_CONFIG.name,
                description     : PROJECT_FILES_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_DOCS,
                iconSvg         : PROJECT_DOCS_CONFIG.iconSvg,
                title           : PROJECT_DOCS_CONFIG.name,
                description     : PROJECT_DOCS_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_GOALS,
                iconSvg         : PROJECT_GOALS_CONFIG.iconSvg,
                title           : PROJECT_GOALS_CONFIG.name,
                description     : PROJECT_GOALS_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_DISCUSSION,
                iconSvg         : PROJECT_DISCUSSION_CONFIG.iconSvg,
                title           : PROJECT_DISCUSSION_CONFIG.name,
                description     : PROJECT_DISCUSSION_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_MEETINGS,
                iconSvg         : PROJECT_MEETINGS_CONFIG.iconSvg,
                title           : PROJECT_MEETINGS_CONFIG.name,
                description     : PROJECT_MEETINGS_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },

            gd.modules.expenses.enabled ? {
                typeId          : ViewType.PROJECT_EXPENSES,
                iconSvg         : PROJECT_EXPENSES_CONFIG.iconSvg,
                title           : PROJECT_EXPENSES_CONFIG.name,
                description     : PROJECT_EXPENSES_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_EXPENSES),
                proFeature      : Feature.EXPENSES,
                formComponent   : AddViewPreviewDefaultForm,
            } : null

        ]
    })

    // PLANNING

    res.push({
        type        : AddView_GroupType.GROUP,
        id          : 'planning',
        icon        : 'i5-gantchart2',
        title       : 'Planning & Resources',
        items       : [
            {
                typeId          : ViewType.PROJECT_GANTT,
                iconSvg         : PROJECT_GANTT_CONFIG.iconSvg,
                title           : PROJECT_GANTT_CONFIG.name,
                description     : PROJECT_GANTT_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_GANTT),
                proFeature      : Feature.GANTT,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_WORKLOAD,
                iconSvg         : PROJECT_WORKLOAD_CONFIG.iconSvg,
                title           : PROJECT_WORKLOAD_CONFIG.name,
                description     : PROJECT_WORKLOAD_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_WORKLOAD),
                proFeature      : Feature.WORKLOAD,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_SUMMARY,
                iconSvg         : PROJECT_SUMMARY_CONFIG.iconSvg,
                title           : PROJECT_SUMMARY_CONFIG.name,
                description     : PROJECT_SUMMARY_CONFIG.description,
                isPro           : !gd.company.license.projectView(ViewType.PROJECT_SUMMARY),
                formComponent   : AddViewPreviewDefaultForm,
            },
        ]
    })

    // REPORTS

    res.push({
        title   : 'Progress & Reports',
        type    : AddView_GroupType.GROUP,
        id      : 'progress',
        icon    : 'i5-chart-bar',
        items   : [
            {
                typeId          : ViewType.PROJECT_ACTIVITY,
                iconSvg         : PROJECT_ACTIVITY_CONFIG.iconSvg,
                title           : PROJECT_ACTIVITY_CONFIG.name,
                description     : PROJECT_ACTIVITY_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            },
            {
                typeId          : ViewType.PROJECT_REPORTS,
                iconSvg         : PROJECT_REPORTS_CONFIG.iconSvg,
                title           : PROJECT_REPORTS_CONFIG.name,
                description     : PROJECT_REPORTS_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm,
            }
        ]
    })

    res.push({type: AddView_GroupType.SEPARATOR})

    // DASHBOARD

    res.push({
        title           : 'Dashboard',
        type            : AddView_GroupType.GROUP,
        id              : 'dashboard',
        icon            : 'i5-dashboard',
        skipItemsList   : true,
        items           : [
            {
                typeId          : ViewType.PROJECT_DASHBOARD,
                iconSvg         : PROJECT_DASHBOARD_CONFIG.iconSvg,
                title           : PROJECT_DASHBOARD_CONFIG.name,
                description     : PROJECT_DASHBOARD_CONFIG.description,
                formParams      : {
                    projectId: projectId
                },
                formComponent   : AddViewPreviewDashboardForm,
            }
        ]
    })

    return res
}
